import { forwardRef } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import NextLink from 'next/link';
import MuiLink from '@mui/material/Link';

const NextLinkComposed = forwardRef(function NextLinkComposed(props, _ref) {
  const {
    to,
    linkAs,
    replace,
    scroll,
    shallow,
    prefetch = null,
    locale,
    ...other
  } = props;

  return (
    <NextLink
      href={to.href || to}
      prefetch={prefetch}
      as={to.as || linkAs}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      passHref
      locale={locale}
      {...other}
    />
  );
});

const Link = forwardRef(function Link(props, ref) {
  const {
    activeClassName = 'active',
    as,
    className: classNameProps,
    to,
    linkAs: linkAsProp,
    locale,
    prefetch,
    replace,
    scroll,
    shallow,
    ...other
  } = props;

  const router = useRouter();
  const pathname = typeof to === 'string' ? to : to.pathname;
  const className = clsx(classNameProps, {
    [activeClassName]:
      router.pathname.split('/')[1] === pathname.split('/')[1] &&
      activeClassName,
  });

  const isExternal =
    typeof to === 'string' &&
    (to.startsWith('http') || to.startsWith('mailto:'));

  if (isExternal) {
    return <MuiLink className={className} href={to} ref={ref} {...other} />;
  }

  const linkAs = linkAsProp || as;
  const nextjsProps = {
    to,
    linkAs,
    replace,
    scroll,
    shallow,
    prefetch,
    locale,
  };

  return (
    <MuiLink
      component={NextLinkComposed}
      className={className}
      ref={ref}
      {...nextjsProps}
      {...other}
    />
  );
});

export default Link;
